import { faCheck, faPlus, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import {
  Card,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  Button,
  Typography,
  CardContent,
  IconButton,
} from '@material-ui/core';
import { WebAsset } from '@material-ui/icons';
import * as moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import BasicTab from '../../../components/form/BasicTab';
import MyButton from '../../../components/form/MyButton';
import TabPanel from '../../../components/layout/TabPanel';
import axios from 'axios';
import { URL_API } from '../../../constants/settings';
import { formatError } from '../../../components/utils/FormatData';
import { useAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import { DatePicker, KeyboardDatePicker,  } from '@material-ui/pickers';


const OngletDetail = (props) => {
  const {
    width,
    value,
    equipment,
    auth,
    classes,
    setNeedUpdate,
    handleOpenCommentOt,
    handleCreateOt,
    setAcknowledgeAllAlarms,
    acknowledgeAllAlarms,
    btnDownloadMivisuLogIsLoading,
    handleDownloadLogMivisu,
    generateCardOt,
    generateCardAlarmes,
    wsStatus,
  } = props;
  const alert = useAlert();
  const [displayBtnAcquitAlarm, setDisplayBtnAcquitAlarm] = useState(false);
  const [pilotable, setPilotable] = useState(equipment?.pilotable);
  const [url, setUrl] = useState(equipment?.url ? equipment.url : '');
  const [urlOrigin, setUrlOrigin] = useState(equipment?.url ? equipment.url : '');
  const [selectedLogMivisuDate, handleLogMivisuDateChange] = useState(moment());

  useEffect(() => {
    setDisplayBtnAcquitAlarm(false);
    if (equipment?.alarmesActives) {
      for (const a of equipment.alarmesActives) {
        if (a.acquitEtat === false) {
          setDisplayBtnAcquitAlarm(true);
        }
      }
    }
  }, [equipment]);

  const handleOnChangePilotable = (value) => {
    axios({ method: 'put', url: URL_API + '/equipements/' + equipment.id + '/pilotable', params: { pilotable: !value } })
      .then(function(res) {
        setPilotable(!value);
        alert.success(`L'élément indiquant si l'équipement [${equipment.id}] accepte les commandes vient d'être modifié`);
      })
      .catch(function(err) {
        formatError(alert, err);
      });
  };

  const handleOnChangeUrl = (value) => {
    if (value !== urlOrigin) {
      axios({ method: 'put', url: URL_API + '/equipements/' + equipment.id + '/url', params: { url: value } })
        .then(function() {
          setUrlOrigin(value);
          alert.success(`L'adresse de la page d'administration de l'équipement [${equipment.id}] a bien été changé`);
        })
        .catch(function(err) {
          formatError(alert, err);
        });
    }
  };

  const handleKeyPressUrl = (e) => {
    if (e.key === 'Enter' || e.nativeEvent.code === 'Enter' || e.nativeEvent.code === 'NumpadEnter') {
      handleOnChangeUrl(e.target.value);
    }
  };

  const handleOnLeaveUrl = (e) => {
    handleOnChangeUrl(e.target.value);
  };

  const CardCaracteristique = (props) =>
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2} {...props}>
      <Card style={{ width: '100%' }} >
        <CardContent className={classes.cardContentCaracteristique}>
          <Typography className={classes.title} color='textSecondary'>
            {props.libelle}
          </Typography>
          <Typography variant='body1'>
            {props.valeur}
          </Typography>
        </CardContent>
      </Card>
    </Grid>

  if (isMobile) {
    return (
      <TabPanel className={classes.tabPanel} value={value} index={0} style={{ width: '100%' }}>
        <div className='row' style={{
          flexDirection: 'column',
          borderBottom: '2px solid #E4E8EC',
          paddingBottom: '5px',
          margin: '10px 10px 0 10px',
        }}>
          <div className='title-sub-rubrique' style={{ fontSize: '2.5vw' }}>Caractéristiques de l'équipement</div>
          <Grid container spacing={2} direction={'row'}>
            <Grid item container spacing={2} direction={'row'} alignItems={'center'}>
              <CardCaracteristique libelle={'Famille'} valeur={equipment.famille} />
              <CardCaracteristique libelle={'Localisation'} valeur={equipment.autoroute + ' sens' + equipment.sens + ' PR ' + equipment.pr} />
              <Grid item xs={12} sm={2} md={4} xl={2}>
                <FormControlLabel control={<Checkbox
                  checked={pilotable}
                  onClick={(e) => handleOnChangePilotable(pilotable)}
                  color='default'
                  disabled={(auth.profil !== 1 && auth.profil !== 2) || !props.wsStatus}
                />} label='Pilotable' />
              </Grid>
              <Grid item xs={12} sm={10} md={12} lg={12} xl={6}>
                <Grid container alignItems={'center'}>
                  <Grid item xs>
                    <TextField
                      label='url'
                      value={url}
                      variant='outlined'
                      onKeyPress={handleKeyPressUrl}
                      onBlur={handleOnLeaveUrl}
                      onChange={(e) => setUrl(e.target.value)}
                      disabled={(auth.profil !== 1 && auth.profil !== 2) || !props.wsStatus}
                      fullWidth />
                  </Grid>
                  {
                    url &&
                    <Grid item>
                      <IconButton
                        color="primary" aria-label="Ouvrir"
                        onClick={() => window.open(url, "_blank")}
                      ><WebAsset /></IconButton>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </Grid>
            {equipment.attributs &&
            <Grid item container spacing={2} direction={'row'}>
              {
                equipment.attributs.map((attribut, j) => {
                  return (
                    <CardCaracteristique key={'attribut_' + j} libelle={attribut.libelle} valeur={attribut.valeur} />
                  );
                })
              }
            </Grid>
            }
          </Grid>
        </div>
        <div className='row' style={{
          flexDirection: 'column',
          borderBottom: '2px solid #E4E8EC',
          paddingBottom: '5px',
          margin: '0 10px 0 10px',
        }}>
          <div className='title-sub-rubrique'
               style={{ fontSize: '2.5vw', justifyContent: 'space-between' }}>
            Alarmes
            {
              (auth.profil === 1 || auth.profil === 2 || auth.profil === 3) && displayBtnAcquitAlarm &&
              <MyButton
                className='classic-button btn-default color-fond-vert'
                type='button'
                labelImportant='Acquitter les alarmes'
                href='#'
                iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                onClick={() => setAcknowledgeAllAlarms(!acknowledgeAllAlarms)}
              />
            }
          </div>
          <div className='list-card'>
            {
              equipment.alarmesActives.map((anAlarme, i) => {
                return (
                  <Card key={'paper-alarm-' + i} className={classes.cardAlarm} style={generateCardAlarmes(anAlarme)}>
                    <div className='card-alarm-header'>
                      <div className='card-alarm-type'>{anAlarme.typeAlarmeLibelle}</div>
                      <div
                        className='card-alarm-date'>{anAlarme.dateDeb ? moment(anAlarme.dateDeb).format('DD/MM/YYYY à HH:mm') : ''}</div>
                    </div>
                    <div className='card-alarm-equipment'>
                      <div className='card-alarm-equipment-id'>{anAlarme.equipementIdSociete}</div>
                      <div className='card-alarm-equipment-toponyme'>{anAlarme.equipementToponyme}</div>
                    </div>
                  </Card>
                );
              })
            }
            {
              (!equipment.alarmesActives || equipment.alarmesActives.length === 0) &&
              <div style={{ display: 'flex', justifyContent: 'center' }}><h5>Aucune donnée à afficher</h5></div>
            }
          </div>
        </div>
        {
          ( equipment.mivisu && equipment.famille !== 'PKG' ) &&
          <div className='row' style={{
            flexDirection: 'column',
            borderBottom: '2px solid #E4E8EC',
            paddingBottom: '5px',
            margin: '0 10px 0 10px',
          }}>
            <div className='title-sub-rubrique'
                 style={{ fontSize: '2.5vw', justifyContent: 'space-between' }}>Logs Mivisu
              <KeyboardDatePicker
                label="Date du fichier"
                inputVariant="outlined"
                format="DD/MM/YYYY"
                minDate={moment().subtract(30, 'days')}
                maxDate={moment()}
                value={selectedLogMivisuDate}
                onChange={handleLogMivisuDateChange}
              />
              { props.wsStatus &&
              <MyButton
                className='classic-button btn-default color-fond-vert'
                type='button'
                labelImportant='Télécharger'
                href='#'
                iconLeft={{ icon: faArrowDown, type: 'fontAwesome' }}
                isLoading={btnDownloadMivisuLogIsLoading}
                onClick={() => handleDownloadLogMivisu(selectedLogMivisuDate)}
              />
              }
              { !props.wsStatus &&
              <MyButton
                className='classic-button btn-default color-fond-gris'
                type='button'
                labelImportant='Télécharger'
                href='#'
                iconLeft={{ icon: faArrowDown, type: 'fontAwesome' }}
                styleCss={{ cursor: 'default' }}
              />
              }
            </div>
          </div>
        }
        <div className='row' style={{
          flexDirection: 'column',
          borderBottom: '2px solid #E4E8EC',
          paddingBottom: '5px',
          margin: '0 10px 0 10px',
        }}>
          <div className='title-sub-rubrique'
               style={{ fontSize: '2.5vw', justifyContent: 'space-between' }}>
            Ordres de travail
            {
              (auth.profil === 1 || auth.profil === 2 || auth.profil === 3) && displayBtnAcquitAlarm &&
              <MyButton
                className='classic-button btn-default color-fond-vert'
                type='button'
                labelImportant='Ajouter un ordre'
                href='#'
                iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                onClick={() => handleCreateOt()}
              />
            }
          </div>
          <div className='list-card'>
            {
              equipment.otsActifs.map((anOt, j) => {
                return (
                  <Card key={'paper-alarm-' + j} className={classes.cardOt} onClick={() => handleOpenCommentOt(anOt)}>
                    <div className='card-ot-icon'>
                      {generateCardOt(anOt)}
                    </div>
                    <div className='card-ot-detail'>
                      <div className='card-ot-header'>
                        <div
                          className='card-ot-date'>{anOt.dateDeb ? moment(anOt.dateDeb).format('DD/MM/YYYY à HH:mm') : ''}</div>
                        <div>{anOt.jobType} - {anOt.id} - {anOt.priorite.code}</div>
                      </div>
                      <div>{anOt.jobDescription}</div>
                    </div>
                  </Card>
                );
              })
            }
          </div>
          {
            (!equipment.otsActifs || equipment.otsActifs.length === 0) &&
            <div style={{ display: 'flex', justifyContent: 'center' }}><h5>Aucune donnée à afficher</h5></div>
          }
        </div>
      </TabPanel>
    );
  }

  return (
    <TabPanel className={classes.tabPanel} value={value} index={0} style={{ width: '100%' }}>
      <div className='overflow-auto' style={{ overflow: 'auto', height: 'calc(90vh - 145px)' }}>
        <div className='row' style={{ flexDirection: 'column' }}>
          <div className='title-sub-rubrique' style={{ fontSize: '1vw' }}>Caractéristiques de l'équipement</div>
          <Grid container spacing={2} direction={'row'} style={{ width: '99%' }}>
            <Grid item container spacing={2} direction={'row'} alignItems={'center'}>
              <CardCaracteristique libelle={'Famille'} valeur={equipment.famille} />
              <CardCaracteristique libelle={'Localisation'} valeur={equipment.autoroute + ' sens' + equipment.sens + ' PR ' + equipment.pr} />
              <Grid item xs={12} sm={2} md={4} xl={2}>
                <FormControlLabel control={<Checkbox
                  checked={pilotable}
                  onClick={(e) => handleOnChangePilotable(pilotable)}
                  color='default'
                  disabled={(auth.profil !== 1 && auth.profil !== 2) || !props.wsStatus}
                />} label='Pilotable' />
              </Grid>
              <Grid item xs={12} sm={10} md={12} lg={12} xl={6}>
                <Grid container alignItems={'center'}>
                  <Grid item xs>
                    <TextField
                      label='url'
                      value={url}
                      variant='outlined'
                      onKeyPress={handleKeyPressUrl}
                      onBlur={handleOnLeaveUrl}
                      onChange={(e) => setUrl(e.target.value)}
                      disabled={(auth.profil !== 1 && auth.profil !== 2) || !props.wsStatus}
                      fullWidth />
                  </Grid>
                  {
                    url &&
                    <Grid item>
                      <IconButton
                        color="primary" aria-label="Ouvrir"
                        onClick={() => window.open(url, "_blank")}
                      ><WebAsset /></IconButton>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </Grid>
            {equipment.attributs &&
            <Grid item container spacing={2} direction={'row'}>
              {
                equipment.attributs.map((attribut, j) => {
                  return (
                    <CardCaracteristique key={'attribut_' + j} libelle={attribut.libelle} valeur={attribut.valeur} />
                  );
                })
              }
            </Grid>
            }
          </Grid>
        </div>
        <div className='row' style={{ flexDirection: 'column', marginTop: '50px' }}>
          <div className='title-sub-rubrique' style={{ fontSize: '1vw' }}>Alarmes</div>
          <BasicTab
            style={{
              header: {
                row: {
                  backgroundColor: '#F0F3F6',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
              datas: {
                row: {
                  borderBottom: '1px solid #EBEEF1',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                }
              },
            }}
            width={'100%'}
            headers={['date apparition', 'acquitée', 'date acq.', 'motif acq.', 'id societe', 'toponyme', 'alarme']}
            columns={['dateDeb', 'acquitEtat', 'acquitDate', 'acquitMotifLibelle', 'equipementIdSociete', 'equipementToponyme', 'typeAlarmeLibelle']}
            datas={equipment.alarmesActives}
            openExternalTab={null}
            setNeedUpdate={null}
            auth={auth}
          />
        </div>
        <div className='row' style={{ flexDirection: 'row'}}>
          {
            props.wsStatus && (auth.profil === 1 || auth.profil === 2 || auth.profil === 3) && displayBtnAcquitAlarm &&
            <MyButton
              className='classic-button btn-default color-fond-vert'
              type='button'
              labelImportant='Acquitter toutes les alarmes'
              href='#'
              iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
              onClick={() => setAcknowledgeAllAlarms(!acknowledgeAllAlarms)}
            />
          }
          {
            !props.wsStatus && (auth.profil === 1 || auth.profil === 2 || auth.profil === 3) && displayBtnAcquitAlarm &&
            <MyButton
              className='classic-button btn-default color-fond-gris'
              type='button'
              labelImportant='Acquitter toutes les alarmes'
              href='#'
              iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
              styleCss={{ cursor: 'default' }}
            />
          }
        </div>
          {
            ( equipment.mivisu && equipment.famille !== 'PKG' ) &&
        <div className='row' style={{ flexDirection: 'column', marginTop: '50px' }}>
          <div className='title-sub-rubrique' style={{ fontSize: '1vw' }}>Fichiers de log Mivisu</div>
          <div className='row' style={{flexDirection: 'row'}}>
            <KeyboardDatePicker
              label="Date du fichier"
              inputVariant="outlined"
              format="DD/MM/YYYY"
              minDate={moment().subtract(30, 'days')}
              maxDate={moment()}
              value={selectedLogMivisuDate}
              onChange={handleLogMivisuDateChange}
            />
            { props.wsStatus &&
            <MyButton
              className='classic-button btn-default color-fond-vert'
              type='button'
              labelImportant='Télécharger'
              href='#'
              iconLeft={{ icon: faArrowDown, type: 'fontAwesome' }}
              isLoading={btnDownloadMivisuLogIsLoading}
              onClick={() => handleDownloadLogMivisu(selectedLogMivisuDate)}
            />
            }
            { !props.wsStatus &&
            <MyButton
              className='classic-button btn-default color-fond-gris'
              type='button'
              labelImportant='Télécharger'
              href='#'
              iconLeft={{ icon: faArrowDown, type: 'fontAwesome' }}
              styleCss={{ cursor: 'default' }}
            />
            }
          </div>
        </div>
          }
        <div className='row' style={{ flexDirection: 'column', marginTop: '50px' }}>
          <div className='title-sub-rubrique' style={{ fontSize: '1vw' }}>Ordre de travail en cours</div>
          <BasicTab
            style={{
              header: {
                row: {
                  backgroundColor: '#F0F3F6',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
              datas: {
                row: {
                  borderBottom: '1px solid #EBEEF1',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
            }}
            width={'100%'}
            headers={['date création', 'description equipement', 'type interv.', 'priorité', 'description intervention', 'statut', '']}
            columns={['dateDeb', 'eqpDescription', 'jobType', 'priorite', 'jobDescription', 'userStatus']}
            datas={equipment.otsActifs}
            openExternalTab={'url'}
            showDetail={true}
            setNeedUpdate={null}
            handleOpenDetail={handleOpenCommentOt}
            auth={auth}
            wsStatus={props.wsStatus}
          />
        </div>
        <div className='row' style={{ flexDirection: 'row'}}>
          {
            props.wsStatus && (auth.profil === 1 || auth.profil === 2 || auth.profil === 3) &&
            <MyButton
              className='classic-button btn-default color-fond-vert'
              type='button'
              labelImportant='Ajouter un ordre de travail'
              href='#'
              iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
              onClick={handleCreateOt}
            />
          }
          {
            !props.wsStatus && (auth.profil === 1 || auth.profil === 2 || auth.profil === 3) &&
            <MyButton
              className='classic-button btn-default color-fond-vert'
              type='button'
              labelImportant='Ajouter un ordre de travail'
              href='#'
              iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
              styleCss={{ cursor: 'default' }}
            />
          }
        </div>
      </div>
    </TabPanel>
  );

};

export default OngletDetail;